( function( $ ) {
	let initBlock = function( section = false ) {
		const $section = section ? $( section ) : $( '.section-woo-shop' );

		$section.each( function() {
			const $sectionInstance = $( this );

			$sectionInstance.find( '.js-woo-shop' ).each( function() {
				const $slider = $( this );

				if ( this.swiper ) {
					this.swiper.destroy( true, true );
				}

				const $swiperSlide = $slider.find( '.swiper-slide' );
				const $swiperNavigation = $slider.siblings( '.section-woo-shop__head' );
				const $swiperButtonPrev = $swiperNavigation.find( '.swiper-button-prev' );
				const $swiperButtonNext = $swiperNavigation.find( '.swiper-button-next' );

				let loop = true;
				let customPagination = false;
				let sliderColumns = {
					breakpoint768: 3,
					breakpoint1280: 6
				};	

				if ( $slider.attr( 'data-layout' ) === 'four_columns' ) {
					sliderColumns = {
						breakpoint768: 2,
						breakpoint1280: 4
					};
				}				

				$swiperButtonPrev.removeClass( 'swiper-button-lock' );
				$swiperButtonPrev.removeAttr( 'disabled' );
				$swiperButtonNext.removeClass( 'swiper-button-lock' );
				$swiperButtonNext.removeAttr( 'disabled' );			

				const sliderBreakPointsSettings = () => {
					if ( $swiperSlide.length <= 1 && window.matchMedia( 'screen and (max-width: 767px)' ).matches ) {
						loop = false;
						customPagination = true;
					} else if ( $swiperSlide.length <= 2 && window.matchMedia( 'screen and (min-width: 768px)' ).matches ) {
						loop = false;
						customPagination = true;
					} else if ( $swiperSlide.length <= 4 && window.matchMedia( 'screen and (min-width: 1280px)' ).matches ) {
						loop = false;
						customPagination = true;
					}
				};

				const shopSlider = () => {
					sliderBreakPointsSettings();
					
					new Swiper( $slider[0], {
						slidesPerView: 1,
						slidesPerGroup: 1,
						spaceBetween: 0,
						centeredSlides: false,
						loop: loop,
						speed: 400,
						autoHeight: true,
						slideToClickedSlide: false,
						a11y: {
							enabled: false
						},
						simulateTouch: false,
						breakpoints: {
							768: {
								spaceBetween: 20,
								slidesPerView: sliderColumns.breakpoint768,
							},
							1280: {
								spaceBetween: 20,
								slidesPerView: sliderColumns.breakpoint1280,
							},
						},
						navigation: {
							nextEl: $swiperButtonNext[0],
							prevEl: $swiperButtonPrev[0],
						},
						pagination: {
							el: $swiperNavigation.find( '.swiper-pagination' )[0],
							type: 'fraction',
						},
						on: {
							afterInit: function() {
								window.app.swiperPaginationHelper( $swiperNavigation, true );
	
								if ( customPagination ) {
									$swiperNavigation.find( '.swiper-pagination .swiper-pagination-total' ).text( $swiperSlide.length );
								}
							},
						}
					} );					
				};

				window.app.loadVendor( 'Swiper', shopSlider );
			} );
		} );
	};


	window.app.loadBlock( initBlock, 'section-woo-shop', '.section-woo-shop' );
} )( jQuery );